module.exports = __webpack_public_path__ + "img/29.823b9195.jpg";